export const environment = {

    // payplus: {
    //     mode: 'sandbox', // 'sandbox' | 'live'
    //     merchantId: 'SB2506000052',
    //     secret: 'dcb08a7b3e8ec241d02f874c465e8c22e4522ca3d4808b122b2ce8cc63057dd1',
    //     applicationKey: 'kJW6Ul2xggyDKlbEw7xu0cLi4Q6iefqcjF0Idv9lGRc'
    // },
    production: true,
    payplus: {
        mode: 'live', // 'sandbox' | 'live'
        merchantId: 'RETAI2507000025',
        secret: 'fba0ba6504f48104b9eb91f66637fbf8ec50c51e5745ac8211a2e5ba994e65ad',
        applicationKey:'QFoG4qz2wAQU7AMIYgcgiHX7Pg490yyRmECPWSkj-Tc' // change this

    },
};
